module.exports = __webpack_public_path__ + "img/edu.45887ac3.png";